import React from "react";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";

const DOT_GREEN = "#4caf50";
const DOT_ACCENT = "#E8A33D";
const DOT_RED = "#f44336";

function getDotColor(value) {
  if (value === null || value === undefined) return DOT_RED;
  return value > 0 ? DOT_GREEN : "rgba(255,255,255,0.25)";
}

function getValue(value) {
  if (value === null || value === undefined) return 0;
  return value;
}

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "0.5rem 1.2rem",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "11px",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "rgba(255,255,255,0.55)",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    backgroundColor: "rgba(28, 30, 32, 0.82)",
    backdropFilter: "blur(8px)",
    borderRadius: "10px",
    pointerEvents: "auto",
  },
  statusRow: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },
  hint: {
    fontSize: "10px !important",
    color: "rgba(255, 255, 255, 0.35) !important",
    fontWeight: "500 !important",
    letterSpacing: "0.06em !important",
    lineHeight: "1 !important",
    fontFamily: "'JetBrains Mono', monospace !important",
    textTransform: "none",
    fontStyle: "italic",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: "0.4rem",
  },
  dot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  label: {
    fontSize: "11px !important",
    color: "rgba(255, 255, 255, 0.55) !important",
    fontWeight: "600 !important",
    letterSpacing: "0.08em !important",
    lineHeight: "1 !important",
    fontFamily: "'JetBrains Mono', monospace !important",
    textTransform: "uppercase",
  },
  value: {
    color: "#E8A33D !important",
    fontWeight: "700 !important",
  },
});

function SystemStatusBar({ classes, platformStats }) {
  const { serversOnline, playersSearching, activeMatches } = platformStats || {};

  const items = [
    {
      value: serversOnline,
      label: "SERVERS",
      color: getDotColor(serversOnline),
    },
    {
      value: playersSearching,
      label: "SEARCHING",
      color: getDotColor(playersSearching),
    },
    {
      value: activeMatches,
      label: "ACTIVE MATCHES",
      color: getDotColor(activeMatches),
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.statusRow}>
        {items.map(({ label, value, color }) => (
          <div key={label} className={classes.item}>
            <span
              className={classes.dot}
              style={{
                backgroundColor: color,
                boxShadow:
                  color === DOT_GREEN || color === DOT_ACCENT
                    ? `0 0 5px ${color}88`
                    : "none",
              }}
            />
            <Typography className={classes.label}>
              {label}:{" "}
              <span
                className={classes.value}
                style={{
                  color:
                    getValue(value) > 0
                      ? "#E8A33D"
                      : "rgba(255,255,255,0.35)",
                }}
              >
                {getValue(value)}
              </span>
            </Typography>
          </div>
        ))}
      </div>
      <Typography className={classes.hint}>
        Servers scale up automatically when players search
      </Typography>
    </div>
  );
}

export default withStyles(styles)(SystemStatusBar);